import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { DadosPessoaisAba1DTO } from "../../model/dadoaPessoaisAba1.dto";
import { environment } from 'environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class DadosPortadorDeficienciaServiceAba6 extends GenericService {
    private path = environment.url + 'api/v1/portador-deficiencia';

    constructor(http: HttpClient) {
        super(http);
    }

    getDadosDeficiencia(): Observable<any> {
        return this.http.get<any>(this.path);
    }

    atualizarDadosDeficiencia(data): Observable<any> {
        return this.http.patch(this.path, data);
    }
}